// Inspired by the generic bo_nested_form_controller.js but specific to schedule ONLY

import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["links", "template"];

  connect() {}

  addAssociation(event) {
    event.preventDefault();
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    let position = "beforebegin";
    const specificPosition = this.linksTarget.dataset.position;
    if (specificPosition) {
      position = specificPosition;
    }
    this.linksTarget.insertAdjacentHTML(position, content);
    const modButton = this.element.querySelectorAll(".modify-button");
    setTimeout(() => modButton[modButton.length - 1].click());
  }

  removeAssociation(e) {
    e.preventDefault();

    const wrapper = e.target.closest(".schedule-wrapper");

    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove();
    } else {
      wrapper.querySelector(".delete-wrapper").querySelector("input[name*='_destroy']").value = 1;
      wrapper.style.display = "none";
    }
  }
}
